import React from 'react';
import { Alert, Button, Paper } from '@mui/material';
import Grid from '@mui/material/Grid';
import ApplicationTooBar from '../molecule/ApplicationToolBar';
import OrderStepBar, { Process } from '../molecule/OrderStepBar';

export type OrderInfoNotFoundProps = {
    appBarLabel?: string;
    process?: Process;
    message?: string;
    onNavigateHome: () => void;
    homeButtonLabel?: string;
};

const defaultMessage = `配送情報が取得できませんでした。
ブラウザ更新等により画面遷移時の情報が失われた可能性があります。`;

export const OrderInfoNotFound = ({
    appBarLabel = '配送依頼完了',
    process = Process.Complete,
    message = defaultMessage,
    onNavigateHome,
    homeButtonLabel = 'ホームに戻る',
}: OrderInfoNotFoundProps) => {
    return (
        <Grid container justifyContent="center" spacing={1}>
            <Grid item xs={12} sm={12}>
                <ApplicationTooBar label={appBarLabel} />
            </Grid>
            <Grid item xs={12} sm={12}>
                <Grid container spacing={1} justifyContent="center">
                    <Grid item xs={12} sm={12}>
                        <OrderStepBar process={process} />
                    </Grid>
                    <Grid item xs={11} sm={11}>
                        <Paper elevation={0} sx={{ p: 1, mb: 2 }}>
                            <Alert severity="error" sx={{ whiteSpace: 'pre-line' }}>
                                {message}
                            </Alert>
                        </Paper>
                    </Grid>
                    <Grid item xs={11} sm={11} display="flex" justifyContent="center">
                        <Button
                            variant="contained"
                            onClick={onNavigateHome}
                            sx={{ maxWidth: 300, alignSelf: 'center' }}
                        >
                            {homeButtonLabel}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
